module.exports = __webpack_public_path__ + "static/media/icon-calendar-orange.f41f830f.svg";